import { _ as __awaiter, a as __generator } from '../_tslib-6fadb982.js';
var sleep = function (delay) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2 /*return*/, new Promise(function (resolve) {
        setTimeout(function () {
          resolve('sleep end');
        }, delay);
      })];
    });
  });
};
export default sleep;